export default __webpack_public_path__ + "static/media/privacy.2f73864d.svg";